import { ExternalIntegrationCard } from '../ExternalIntegrationCard/ExternalIntegrationCard'
import { XIntegration, ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { Twitter } from 'almanac-ui/icons'
import { CardButtons } from './CardButtons'
import XInitialization from 'components/IntegrationInitialization/XInitialization/XInitialization'
import { useModals } from 'almanac-ui/Modal'

export const XCard = ({
  integrations = [],
  isDisconnected = false,
}: {
  integrations?: XIntegration[]
  isDisconnected?: boolean
}) => {
  const { openModal } = useModals()

  return (
    <ExternalIntegrationCard
      title={'X (formerly Twitter)'}
      description={'Post directly to your X timeline'}
      integrations={integrations}
      icon={<Twitter size={20} />}
      isDisconnected={isDisconnected}
      buttons={
        <CardButtons
          onConnect={() => openModal(XInitialization)}
          provider={ExternalIntegrationEnum.X}
          isConnected={integrations.length > 0}
          integration={integrations[0]}
          isDisconnected={isDisconnected}
        />
      }
    />
  )
}
